<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <user-edit-form @on-submit="onUserEditSubmit"></user-edit-form>
    </div>
    <div class="md-layout-item md-size-100">
      <user-edit-avatar-upload
        v-if="this.$route.params.id !== undefined && this.isAvatarEnabled"
        label-picker="Foto kiezen"
        label-upload="foto uploaden"
      ></user-edit-avatar-upload>
    </div>
  </div>
</template>
<script>
import UserEditForm from "./UserEditForm.vue";
import UserEditAvatarUpload from "./UserEditAvatarUpload.vue";

export default {
  components: {
    UserEditForm,
    UserEditAvatarUpload
  },
  data() {
    return {
      userEditModel: {}
    };
  },
  methods: {
    onUserEditSubmit(model) {
      this.userEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/' + this.userEditModel.id, Object.assign(this.userEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  },
  computed: {
    isAvatarEnabled() {
      if (this.getModuleSettingFromSession("user_avatar_enabled") === 1) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style></style>
